<template>
  <div id="contenedor-infraestructura-configuracion-tipos-infraestructura-desktop">
    <v-data-table
      :headers="headers"
      :items="listadoTiposInfraestructura">
      <template v-slot:[`item.acciones`]="{ item }">
        <opciones :tipoInfraestructura="item"></opciones>
      </template>
      <!-- <template v-slot:[`item.createdAt`]="{ item }">
        <fecha-humano :fecha="new Date(item.createdAt)"></fecha-humano>
      </template> -->
    </v-data-table>
  </div>
</template>

<script>
import Opciones from './Opciones.vue';

export default {
  name: 'InfraestructuraConfiguracionTiposInfraestructuraDesktop',
  props: {
    listadoTiposInfraestructura: {
      type: Array,
      required: true,
    },
  },
  components: {
    Opciones,
  },
  data() {
    return {
      headers: [
        { text: 'Tipo de Infraestructura', sortable: false, value: 'descripcion' },
        {
          text: '', align: 'end', sortable: false, value: 'acciones',
        },
      ],
    };
  },
};
</script>

<style lang="scss">

</style>
